import { useJanela } from "@/components/JanelaContexto";
import { VoltarInicio } from "@/components/VoltarInicio";

/**
 * Botões de retorno (e informações, em modo dev) agrupados ao título da página.
 * Só aparecem quando a página está rodando dentro de uma janela; fora dela
 * (rota direta) não renderiza nada.
 */
export function BotoesJanela() {
  const emJanela = !!useJanela();
  if (!emJanela) return null;
  return <VoltarInicio icone />;
}
